/* eslint no-new: "off", class-methods-use-this: "off" */

import $ from "jquery";
import "bootstrap/js/dist/popover";

/**
 * auto. async manipulate form field visibility
 * @module formControl
 */
class FormBasicFunctions {
  $businessID = $(".js-business-select");

  $addressID = $(".js-addressType");

  $companyID = $(".js-company");

  $divisionID = $(".js-division");

  constructor() {
    this.formVisibility();
    this.addMissingPlaceholder();
    this.tabFormControl();
    this.popOverInit();
  }

  /**
   * hides business fields
   * @method hideBusinessFields
   */
  hideBusinessFields() {
    if (this.$addressID.val() === "Private") {
      this.$companyID.removeAttr("required");
      this.$divisionID.removeAttr("required");
      this.$businessID.hide();
    }
  }

  /**
   * onChange action for businessIdentifier
   * @private
   */
  onChangeAction() {
    this.$addressID.change(() => {
      this.$businessID.show();
      this.$companyID.attr("required", "required");
      this.$divisionID.attr("required", "required");
      this.hideBusinessFields();
    });
  }

  /**
   * manipulate form field visibility
   */
  formVisibility() {
    if (this.$addressID.length) {
      this.hideBusinessFields();
      this.onChangeAction();
    }
  }

  /**
   * add missing placeholder e.g ie9
   */
  addMissingPlaceholder() {
    /**
     * @type {string}
     */
    const userAgent = window.navigator.userAgent;

    /**
     * current windows version
     * @type {number}
     */
    let currentVersion = 0;

    const windows = userAgent.indexOf("MSIE ");

    if (windows > 0) {
      currentVersion = parseInt(
        userAgent.substring(windows + 5, userAgent.indexOf(".", windows)),
        10
      );
      if (currentVersion <= 9) {
        $("input[placeholder]").each((idx, item) => {
          const $this = $(item);
          if ($this.val() === "") {
            $this
              .val($this.attr("placeholder"))
              .focus(() => {
                if ($this.val() === $this.attr("placeholder")) {
                  $this.val("");
                }
              })
              .blur(() => {
                if ($this.val() === "") {
                  $this.val($this.attr("placeholder"));
                }
              });
          }
        });
        $("form").bind("submit", (event) => {
          event.preventDefault();
          $("input[placeholder]").each((idx, item) => {
            const $this = $(item);
            if ($this.val() === $this.attr("placeholder")) {
              $this.val("");
            }
          });
          event.currentTarget.submit();
        });
      }
    }
  }

  /**
   * tab Form Control
   */
  tabFormControl() {
    const dom = $(".js-contact-form");

    dom.find(".js-tab-header").first().addClass("active");
    dom.find(".js-tab-content").first().addClass("active");
    dom.find(".js-tab-element").first().addClass("active");

    if (dom.find(".js-tab-open").length) {
      dom.find(".js-tab-open").each((idx, item) => {
        $(item).find(".js-tab-header").addClass("active");
        $(item).find(".js-tab-content").addClass("active");
        $(item).find(".js-tab-element").addClass("active");
      });
    }

    // Default hidden content for tabs
    dom
      .find(
        ".js-tab-header.js-tab-menu--hidden, .js-tab-content.js-tab-menu--hidden, .js-tab-element.js-tab-menu--hidden"
      )
      .removeClass("active");

    $(".js-contact-form-submit").click(() => {
      dom
        .find(".js-tab-header, .js-tab-content, .js-tab-element")
        .addClass("active");
    });
  }

  /**
   * initial PopOver
   */
  popOverInit() {
    /**
     * local string for current open popover selector
     *
     * @type {string}
     * @private
     */
    let currentPopOverSelector = "";

    $('[data-toggle="popover"]').popover();

    // set event on all pop over triggers
    $("[data-popover-trigger]").click((e) => {
      // get requested popover selector
      const popOverRequestSelector = $(e.currentTarget).attr(
        "data-popover-trigger"
      );
      // hide all other - they might be open
      $("[data-popover-trigger]").each((idx, item) => {
        const popOverSelector = $(item).attr("data-popover-trigger");
        // if requested/clicked popover trigger
        if (popOverSelector === popOverRequestSelector) {
          // and if is not open so show it
          if (popOverSelector !== currentPopOverSelector) {
            currentPopOverSelector = popOverSelector;
            $(popOverSelector).popover("show");
          }
          // else clear the current selector, so it can opened again
          else {
            $(popOverSelector).popover("hide");
            currentPopOverSelector = "";
          }
        } else {
          $(popOverSelector).popover("hide");
        }
      });
    });
  }
}

(() => {
  new FormBasicFunctions();
})();
